import { render, staticRenderFns } from "./DataSourceSelect.vue?vue&type=template&id=055dd3dd&scoped=true"
import script from "./DataSourceSelect.vue?vue&type=script&lang=js"
export * from "./DataSourceSelect.vue?vue&type=script&lang=js"
import style0 from "./DataSourceSelect.vue?vue&type=style&index=0&id=055dd3dd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055dd3dd",
  null
  
)

export default component.exports